import { render, staticRenderFns } from "./sample-goods.vue?vue&type=template&id=56be8279&"
import script from "./sample-goods.vue?vue&type=script&lang=js&"
export * from "./sample-goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports